export default "__VITE_ASSET__76788a71__"